
// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import bikeImage1 from '../assets/Helmate.png';
// import bikeImage2 from '../assets/Jacket.png';
// import bikeImage3 from '../assets/Helmate.png';
// import bikeImage4 from '../assets/Jacket.png';
// import bikeImage5 from '../assets/Helmate.png';
// import bikeImage6 from '../assets/Helmate.png';
// import AccesoriesSort from '../../Components/Mobile Components/AccesoriesSort/AccesoriesSort';

// // Dummy JSON data for each product
// const products = [
//   { id: 1, name: 'Bell Helmets DLX Shockwave Helmet', price: 11753, image: bikeImage1, quantityAvailable: 2, isNew: true },
//   { id: 2, name: 'AGV K6 Full-Face Helmet', price: 13999, image: bikeImage2, quantityAvailable: 2, isNew: false },
//   { id: 3, name: 'Shoei RF-1400 Helmet', price: 15999, image: bikeImage3, quantityAvailable: 2, isNew: true },
//   { id: 4, name: 'Arai Signet-X Helmet', price: 14500, image: bikeImage4, quantityAvailable: 2, isNew: false },
//   { id: 5, name: 'HJC RPHA 11 Pro Helmet', price: 12799, image: bikeImage5, quantityAvailable: 2, isNew: true },
//   { id: 6, name: 'Scorpion EXO-R420 Helmet', price: 9800, image: bikeImage6, quantityAvailable: 2, isNew: false },
// ];

// function AccessoriesRelevance() {
//   const navigate = useNavigate();
  

//   // State for product quantities
//   const [formData, setFormData] = useState(
//     products.reduce((acc, product) => ({
//       ...acc,
//       [product.id]: { quantity: 0 },
//     }), {})
//   );

//   // State for filtered products
//   const [filteredProducts, setFilteredProducts] = useState(products);

//   // Handle quantity change
//   const handleQuantityChange = (id, value) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       [id]: { ...prevData[id], quantity: value },
//     }));
//   };

//   // Handle form submission
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const formDataObj = new FormData();
//     Object.entries(formData).forEach(([id, { quantity }]) => {
//       formDataObj.append(`product_${id}_quantity`, quantity);
//     });
//     console.log('Form Data submitted:', Object.fromEntries(formDataObj.entries()));
//     navigate('/booking-summary');
//   };

//   // Sorting logic
//   const handleSort = (sortType) => {
//     let sortedProducts = [...products];
//     switch (sortType) {
//       case 'priceLowToHigh':
//         sortedProducts.sort((a, b) => a.price - b.price);
//         break;
//       case 'priceHighToLow':
//         sortedProducts.sort((a, b) => b.price - a.price);
//         break;
//       default:
//         sortedProducts = products; // Relevance (original order)
//     }
//     setFilteredProducts(sortedProducts);
//   };

//   return (
//     <div className="flex justify-center min-h-screen p-5 ">
//         <div className="block lg:hidden absolute bottom-4  z-50 w-full">
//         <AccesoriesSort handleFilter={handleFilter} />
//       </div>

//       <div className="w-full">
//         {/* Sorting bar */}
//         {/* <div className="flex mb-6"> */}
//         <div className="hidden md:flex mb-6">
//           <h2 className="text-lg font-semibold">Sort by:</h2>
//           <div className="flex space-x-4 ml-4">
//             <button className="text-gray-400 hover:text-[#FF9630]" onClick={() => handleSort('relevance')}>
//               Relevance
//             </button>
//             <button className="text-gray-400 hover:text-[#FF9630]" onClick={() => handleSort('priceLowToHigh')}>
//               Price - Low to High
//             </button>
//             <button className="text-gray-400 hover:text-[#FF9630]" onClick={() => handleSort('priceHighToLow')}>
//               Price - High to Low
//             </button>
//           </div>
//         </div>

//         {/* Form */}
//         <form onSubmit={handleSubmit}>
//           {/* Grid layout */}
//           {/* <div className="grid grid-cols-3 gap-4"> */}
//           <div className="grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-4">

//             {filteredProducts.map((product) => (
//               <div key={product.id} className="relative border rounded-lg shadow-lg p-4 bg-white">
//                 {/* New label */}
//                 {product.isNew && (
//                   <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
//                     New
//                   </span>
//                 )}

//                 {/* Centered product image */}
//                 <div className="flex justify-center items-center mb-4  rounded-lg">
//                   <img
//                     src={product.image}
//                     alt={product.name}
//                     className="w-52 h-44 object-cover rounded-lg border p-4"
//                   />
//                 </div>

//                 {/* Product details */}
//                 <h2 className="text-center text-lg font-semibold">{product.name}</h2>
//                 <p className="text-center text-gray-500 text-sm">01 x free</p>

//                 <div className="flex flex-col items-center justify-center rounded-lg p-1 border">
//                   <p className="text-left text-sm mb-2 w-full">Select Quantity</p>

//                   <div className="flex items-center space-x-2 w-full">
//                     <input
//                       type="range"
//                       min="0"
//                       step="1"
//                       max={product.quantityAvailable}
//                       value={formData[product.id]?.quantity || 0}
//                       onChange={(e) => handleQuantityChange(product.id, e.target.value)}
//                       className="w-full accent-red-600 mx-4"
//                     />
//                   </div>

//                   {/* Label for quantity range */}
//                   <div className="flex justify-between w-full mt-1">
//                     {Array.from({ length: product.quantityAvailable + 1 }, (_, i) => (
//                       <span key={i} className="text-sm text-gray-500">{i}</span>
//                     ))}
//                   </div>
//                 </div>

//                 {/* Price and Add button */}
//                 <div className="flex justify-between items-center mt-4">
//                   <span className="text-gray-700 font-semibold">Pay: ₹{product.price}</span>
//                   <button
//                     type="submit"
//                     className="bg-[#FF9630] text-white px-8 py-2 rounded"
//                   >
//                     ADD
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default AccessoriesRelevance;

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import bikeImage1 from '../assets/Helmate.png';
import bikeImage2 from '../assets/Jacket.png';
import bikeImage3 from '../assets/Helmate.png';
import bikeImage4 from '../assets/Jacket.png';
import bikeImage5 from '../assets/Helmate.png';
import bikeImage6 from '../assets/Helmate.png';
import AccesoriesSort from '../../Components/Mobile Components/AccesoriesSort/AccesoriesSort';

// Dummy JSON data for each product
const products = [
  { id: 1, name: 'Bell Helmets DLX Shockwave Helmet', price: 11753, image: bikeImage1, quantityAvailable: 2, isNew: true },
  { id: 2, name: 'AGV K6 Full-Face Helmet', price: 13999, image: bikeImage2, quantityAvailable: 2, isNew: false },
  { id: 3, name: 'Shoei RF-1400 Helmet', price: 15999, image: bikeImage3, quantityAvailable: 2, isNew: true },
  { id: 4, name: 'Arai Signet-X Helmet', price: 14500, image: bikeImage4, quantityAvailable: 2, isNew: false },
  { id: 5, name: 'HJC RPHA 11 Pro Helmet', price: 12799, image: bikeImage5, quantityAvailable: 2, isNew: true },
  { id: 6, name: 'Scorpion EXO-R420 Helmet', price: 9800, image: bikeImage6, quantityAvailable: 2, isNew: false },
];

function AccessoriesRelevance() {
  const navigate = useNavigate();

  // State for product quantities
  const [formData, setFormData] = useState(
    products.reduce((acc, product) => ({
      ...acc,
      [product.id]: { quantity: 0 },
    }), {})
  );

  // State for filtered products
  const [filteredProducts, setFilteredProducts] = useState(products);

  // Handle quantity change
  const handleQuantityChange = (id, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [id]: { ...prevData[id], quantity: value },
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    const formDataObj = new FormData();
    Object.entries(formData).forEach(([id, { quantity }]) => {
      formDataObj.append(`product_${id}_quantity`, quantity);
    });
    console.log('Form Data submitted:', Object.fromEntries(formDataObj.entries()));
    navigate('/booking-summary');
  };

  // Sorting logic
  const handleSort = (sortType) => {
    let sortedProducts = [...products];
    switch (sortType) {
      case 'priceLowToHigh':
        sortedProducts.sort((a, b) => a.price - b.price);
        break;
      case 'priceHighToLow':
        sortedProducts.sort((a, b) => b.price - a.price);
        break;
      default:
        sortedProducts = products; // Relevance (original order)
    }
    setFilteredProducts(sortedProducts);
  };

  return (
    <div className="flex justify-center min-h-screen ">
      
      {/* Mobile Sort Component */}
      <div className="block lg:hidden fixed bottom-4 z-50 w-full">
        <AccesoriesSort handleSort={handleSort} />
      </div>

      <div className="w-full">
       
        <div className="hidden md:flex mb-4">
          <h2 className="text-lg font-semibold">Sort by:</h2>
          <div className="flex space-x-4 ml-4">
            <button className="text-gray-400 hover:text-[#FF9630]" onClick={() => handleSort('relevance')}>
              Relevance
            </button>
            <button className="text-gray-400 hover:text-[#FF9630]" onClick={() => handleSort('priceLowToHigh')}>
              Price - Low to High
            </button>
            <button className="text-gray-400 hover:text-[#FF9630]" onClick={() => handleSort('priceHighToLow')}>
              Price - High to Low
            </button>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredProducts.map((product) => (
              <div key={product.id} className="relative border rounded-lg shadow-lg p-4 bg-white">
                {/* New label */}
                {product.isNew && (
                  <span className="absolute top-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-xs">
                    New
                  </span>
                )}

                {/* Centered product image */}
                <div className="flex justify-center items-center mb-4 rounded-lg">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-52 h-44 object-cover rounded-lg border p-4"
                  />
                </div>

                {/* Product details */}
                <h2 className="text-center text-lg font-semibold">{product.name}</h2>
                <p className="text-center text-gray-500 text-sm">01 x free</p>

                <div className="flex flex-col items-center justify-center rounded-lg p-1 border">
                  <p className="text-left text-sm mb-2 w-full">Select Quantity</p>

                  <div className="flex items-center space-x-2 w-full">
                    <input
                      type="range"
                      min="0"
                      step="1"
                      max={product.quantityAvailable}
                      value={formData[product.id]?.quantity || 0}
                      onChange={(e) => handleQuantityChange(product.id, e.target.value)}
                      className="w-full accent-red-600 mx-4"
                    />
                  </div>

                  {/* Label for quantity range */}
                  <div className="flex justify-between w-full mt-1">
                    {Array.from({ length: product.quantityAvailable + 1 }, (_, i) => (
                      <span key={i} className="text-sm text-gray-500">{i}</span>
                    ))}
                  </div>
                </div>

                {/* Price and Add button */}
                <div className="flex justify-between items-center mt-4">
                  <span className="text-gray-700 font-semibold">Pay: ₹{product.price}</span>
                  <button
                    type="submit"
                    className="bg-[#FF9630] text-white px-8 py-2 rounded"
                  >
                    ADD
                  </button>
                </div>
              </div>
            ))}
          </div>
        </form>
      </div>
    </div>
  );
}

export default AccessoriesRelevance;
